//#region src/agentTypes.ts
const AGENT_LIBRARY_SERVICE_IDENT = "org.aimystic.modules.agents.services.AgentLibraryService";
/** Tags that cannot be added or removed by users — managed by the system only. */
const AGENT_RESERVED_TAGS = ["system", "community"];
const AGENT_SERVICE_V2_IDENT = "org.aimystic.modules.agents.services.AgentServiceV2";
const RPC_EVENT_AGENT_CREATED_IDENT = "org.aimystic.modules.agents.events.AgentCreated";
const RPC_EVENT_AGENT_UPDATED_IDENT = "org.aimystic.modules.agents.events.AgentUpdated";
const RPC_EVENT_AGENT_DELETED_IDENT = "org.aimystic.modules.agents.events.AgentDeleted";
const RPC_EVENT_AGENT_INVITED_IDENT = "org.aimystic.modules.agents.events.AgentInvited";
const RPC_EVENT_AGENT_CREATED = {
	ident: RPC_EVENT_AGENT_CREATED_IDENT,
	description: "Event emitted when an agent is created",
	params: [{
		name: "agent",
		type: "object",
		description: "The agent that was created"
	}]
};
const RPC_EVENT_AGENT_UPDATED = {
	ident: RPC_EVENT_AGENT_UPDATED_IDENT,
	description: "Event emitted when an agent is updated",
	params: [{
		name: "agent",
		type: "object",
		description: "The agent that was updated"
	}]
};
const RPC_EVENT_AGENT_DELETED = {
	ident: RPC_EVENT_AGENT_DELETED_IDENT,
	description: "Event emitted when an agent is deleted",
	params: [{
		name: "agentId",
		type: "string",
		description: "The ID of the agent that was deleted"
	}]
};
const RPC_EVENT_AGENT_INVITED = {
	ident: RPC_EVENT_AGENT_INVITED_IDENT,
	description: "Event emitted when an agent is invited to a workspace room",
	params: [{
		name: "agent",
		type: "object",
		description: "The agent that was invited"
	}, {
		name: "roomId",
		type: "string",
		description: "The workspace room ID the agent was invited to"
	}]
};

//#endregion
export { AGENT_LIBRARY_SERVICE_IDENT, AGENT_RESERVED_TAGS, AGENT_SERVICE_V2_IDENT, RPC_EVENT_AGENT_CREATED, RPC_EVENT_AGENT_CREATED_IDENT, RPC_EVENT_AGENT_DELETED, RPC_EVENT_AGENT_DELETED_IDENT, RPC_EVENT_AGENT_INVITED, RPC_EVENT_AGENT_INVITED_IDENT, RPC_EVENT_AGENT_UPDATED, RPC_EVENT_AGENT_UPDATED_IDENT };
//# sourceMappingURL=agentTypes.js.map